import { isInMccmApp } from "../user-agent/isInMccmApp";

export const canUseAppBridge = () => {
  if (!isInMccmApp()) return false;

  return !!window;
};
